<template>
  <el-dialog v-dialogDragOnly :close-on-click-modal="false" :custom-class="`${customClassName} result-dialog`" :title="$t(title)" append-to-body :visible="visible" :before-close="hideAdd">
    <div class="clearfix" v-if="resultType==='success'">
      <p class="success_prompt"><i class="el-icon-success"></i><span class="content">{{$t(content)}}</span></p>
      <p class="clickable" v-if="showViewDetail" @click="viewDetail">{{$t('portal.cha-kan-xiang-qing')}}</p>
    </div>
    <div class="clearfix" v-else>
      <p class="err_prompt"><i class="el-icon-error"></i><span class="content error">{{$t(content)}}</span></p>
    </div>
    <div class="clearfix extraContent">
      <slot name="extraContent"></slot>
    </div>
    <el-button class="dio-btn" size="mini" type="primary" @click="hideAdd">{{$t('common.done')}}</el-button>
  </el-dialog>
</template>

<script>
export default {
  name: "ResultDialog",
  props: {
    title: {
      type: String,
      default: 'portal.chong-zhi-shen-qing'
    },
    content: {
      type: String,
      default: 'portal.chong-zhi-cheng-gong'
    },
    resultType: {
      type: String,
      default: 'success'
    },
    visible: {
      type: Boolean,
      default: false
    },
    showViewDetail: {
      type: Boolean,
      default: false
    },
    customClassName: {
      type: String,
      default: 'mini-dialog'
    }
  },
  methods: {
    hideAdd() {
      this.$emit('hide');
    },
    viewDetail() {
      this.$emit('viewDetail');
    }
  }
};
</script>

<style lang="less">
.result-dialog {
  text-align: center;
  .clearfix {
    position: relative;
    text-align: center;
    margin-bottom: 10px;
    .success_prompt {
      .el-icon-success {
        font-size: 30px;
        color: #67c23a;
        margin: 30px auto;
      }
      .content {
        position: relative;
        top: -4px;
        left: 10px;
        font-size: 16px;
      }
    }
    .err_prompt {
      .el-icon-error {
        font-size: 30px;
        color: #f56c6c;
        margin: 30px auto;
      }
      .content {
        position: relative;
        top: -4px;
        left: 10px;
        font-size: 16px;
      }
    }
    .clickable {
      margin-bottom: 30px;
      margin-top: -24px;
    }
  }
  .clearfix.extraContent {
    border-top: 1px solid @lc;
    .base-info .el-col .u-label {
      text-decoration: none;
    }
  }
}
</style>